module.exports = __webpack_public_path__ + "static/media/Pump_On_Img.d9bd778e.gif";